<template>
    <v-container fluid>
        <v-layout row justify-center>

            <v-card class="v-sheet theme--light">
                <v-card-title>
                    <div style="padding: 24px 24px 0 24px">
                        <span class="headline">{{$t("Referral Program")}}</span>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md style="padding-top: 0px;">

                        <v-alert outline style="text-align: left;" class="mb-3" :value="alert.visible" :type="alert.type" >
                            {{alert.text}}
                        </v-alert>

                        <div id="recover-password-form" v-show="showForm">
                            <div>{{$t("Enter the email of a friend, and he will receive an email to register in WeLicense!")}}</div>
                            <div>{{$t("When he gets registered, you will recieve more credits!")}}</div>

                            <v-form>
                                <v-text-field prepend-icon="email" name="email" :label="$t('Email')" v-model="email" type="text" required></v-text-field>
                                <v-btn color="primary" dark @click="sendReferral()">{{$t('Send Referral!')}}</v-btn>
                            </v-form>
                        </div>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-layout>


        <!-- Referred Users -->
        <v-layout row justify-center v-if="showReferredUsers" style="margin-top: 35px;">
            <v-card class="v-sheet theme--light">
                <v-card-title>
                    <div style="padding: 24px 24px 0 24px">
                        <span class="headline">{{$t('Users already referred')}}</span>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md style="padding-top: 0px;">

                        <v-alert outline style="text-align: left;" class="mb-3" :value="alertResend.visible" :type="alertResend.type" >
                            {{alertResend.text}}
                        </v-alert>

                        <v-list grid-list-md>
                            <v-list-tile
                                    v-for="item in referredUsersList"
                                    :key="item.title"
                                    avatar
                                    @click=""
                            >

                                <v-list-tile-content>
                                    <v-list-tile-title v-text="item.title"></v-list-tile-title>
                                </v-list-tile-content>


                                <v-list-tile-action>
                                    <v-btn color="primary" dark @click="resendReferral(item.title)">{{$t('Resend!')}}</v-btn>
                                </v-list-tile-action>

                            </v-list-tile>
                        </v-list>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-layout>


    </v-container>
</template>

<script>
    import AuthRepository from "@/repositories/AuthRepository";

    import { VToolbar, VLayout, VToolbarTitle, VBtn, VIcon, VForm, VTextField, VContainer, VAlert,VCard, VCardTitle, VCardText, VList, VListTile, VListTileAction, VListTileContent, VListTileTitle } from 'vuetify/lib'

    export default {
        name: "Referral",
        components: {
            VToolbar, VLayout, VToolbarTitle, VBtn, VIcon, VForm, VTextField, VContainer, VAlert, VCard, VCardTitle, VCardText, VList, VListTile, VListTileAction, VListTileContent, VListTileTitle
        },
        data () {
            return {
                // Alert
                alert: {},
                alertResend: {},
                email: "",
                showForm: true,
                showReferredUsers: false,
                referredUsersList: []
            }
        },
        created() {
            this.checkSentReferrals();
        },
        methods: {
            valid_email:function(mail) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(mail).toLowerCase());
            },
            sendReferral() {
                    if(this.email !== "" && this.valid_email(this.email)){
                        AuthRepository.sendReferral(this.email)
                            .then((response) => {
                                this.alertSuccess(response.data.message);
                            }).catch((error) =>{
                                this.alertError(error.response.data.message);
                            });
                    }else{
                        if(this.email == ""){
                            this.alertError(this.$t('Please, fill the email field'));
                        }else{
                            this.alertError(this.$t('Please, enter a valid email'));
                        }
                    }
            },
            resendReferral(email){
                this.alertResend = {};
                if(email !== "" && this.valid_email(email)){
                    AuthRepository.resendReferral(email)
                        .then((response) => {
                            this.alertResendModal(response.data.message, "success");
                        }).catch((error) =>{
                            this.alertResendModal(error.response.data.message, "error");
                        });
                }else{
                    this.alertResendModal(this.$t('Please, enter a valid email'), "error");
                }
            },
            checkSentReferrals() {
                AuthRepository.checkSentReferrals().then((response) => {

                    if(response.data.usersList && response.data.usersList.length > 0){

                        for(let userEmail of response.data.usersList){
                            this.referredUsersList.push({title: userEmail, avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg' });
                        }

                        this.showReferredUsers = true
                    }else{
                        this.showReferredUsers = false
                    }
                }).catch((error) =>{
                    this.showReferredUsers = false
                });
            },
            alertResendModal(text, type) {
                this.alertResend = {
                    type: type,
                    text: text,
                    visible: true
                }
            },
            alertSuccess(text) {
                this.alert = {
                    type: "success",
                    text: text,
                    visible: true
                }
            },
            alertError(text) {
                this.alert = {
                    type: "error",
                    text: text,
                    visible: true
                }
            },
        }
    }
</script>

<style scoped>

</style>